<template>
   <div>
       <button @click="payButton">Pay!</button>
        <pre><div id="result-json">JSON result will appear here after payment:<br></div></pre> 
   </div>
</template>

<script>
import RequestService from '../../services/requestservice';

import axios from 'axios'
import authHeader from '../../services/auth-header';



export default {
  name: 'Demo',
  data () {
    return {
      tokenSnap : '',

    }
  },
  

  mounted(){

      axios.get('https://37.44.244.162:9090/api/all/getsnaptoken', { headers: authHeader() }).then(response => {
          this.tokenSnap = response.data.message;
      });
  
  },
  methods: {
    deleteData(){
      this.$swal.fire({
        title: 'Peringatan!',
        text: "Apakah anda yakin ingin menghapus data ini?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          const Toast = this.$swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            onOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })
          Toast.fire({
            icon: 'success',
            title: 'Data Berhasil Dihapus'
          })
        } else if (
          result.dismiss === Swal.DismissReason.cancel
        ) {
          this.$swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          )
        }
      })
    },
    postData(){
      var vm = this;
      this.$store.dispatch('request/postInformasiUmum', this.formData)
      .then(() => {
          vm.myModal = false;
          const Toast = this.$swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            onOpen: (toast) => {
              toast.addEventListener('mouseenter', this.$swal.stopTimer)
              toast.addEventListener('mouseleave', this.$swal.resumeTimer)
            }
          })
          Toast.fire({
            icon: 'success',
            title: 'Data Berhasil Ditambah'
          })    
          this.$store.dispatch('request/getInformasiUmum')
      },
        error => {
            alert(error.message);
            vm.$swal.fire({
              title: 'Peringatan!',
              text: error.message,
              icon: 'errorr',
              showCancelButton: true,
            })
        }
      );

    },
    fileUpload(e) {
        // this.formData.file = e.target.files[0];
        this.formData.file = e.target.files[0]
        this.fileName = e.target.files[0].name
    },
    payButton(){
        snap.pay(this.tokenSnap, {
          // Optional
          onSuccess: function(result){
            /* You may add your own js here, this is just example */ document.getElementById('result-json').innerHTML += JSON.stringify(result, null, 2);
          },
          // Optional
          onPending: function(result){
            /* You may add your own js here, this is just example */ document.getElementById('result-json').innerHTML += JSON.stringify(result, null, 2);
          },
          // Optional
          onError: function(result){
            /* You may add your own js here, this is just example */ document.getElementById('result-json').innerHTML += JSON.stringify(result, null, 2);
          }
        });
    }
    
  }
}
</script>